import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Table } from "semantic-ui-react";
import { ventasOps } from "../../../../../ducks/ventas";
import { ventasContactosOps } from "../../../../../ducks/ventasContactos";
import ItemContacto from "./contactos/ItemContacto";

const propTypes = {
  tipo: PropTypes.oneOf(["correo", "telefono", "visita", "externo"]).isRequired
};

class Contactos extends React.Component {
  componentDidMount() {
    this.props.attachListenersPersonasContacto(this.props.colegio.idColegio);
  }

  componentWillUnmount() {
    this.props.limpiarPersonasContacto();
    this.props.detachListenersPersonasContacto(this.props.colegio.idColegio);
  }

  handleClick = ({ personaId, personaNombre, personaFormaContacto }) =>
    this.props.addAccionDeVenta({
      uid: this.props.uid,
      tipo: this.props.tipo,
      colegio: this.props.colegio,
      personaId,
      personaNombre,
      personaFormaContacto
    });

  render() {
    const { colegio, tipo, personasContacto } = this.props;
    return (
      <Table selectable>
        <Table.Body>
          {personasContacto.map(persona => (
            <ItemContacto
              key={`${colegio.idColegio}_${persona.id}_${colegio.tipo}`}
              tipo={tipo}
              handleClick={this.handleClick}
              {...persona}
            />
          ))}
        </Table.Body>
      </Table>
    );
  }
}

Contactos.propTypes = propTypes;

const toProps = (state, ownProps) => ({
  uid: state.session.user.uid,
  personasContacto: state.ventasContactos.personasContacto
});

const actions = {
  addAccionDeVenta: ventasOps.addAccionDeVenta,
  limpiarPersonasContacto: ventasContactosOps.limpiarPersonasContacto,
  attachListenersPersonasContacto:
    ventasContactosOps.attachListenersPersonasContacto,
  detachListenersPersonasContacto:
    ventasContactosOps.detachListenersPersonasContacto
};

export default connect(toProps, actions)(Contactos);



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/Contactos.jsx